import React from "react";
import {
  // AxiosPostSecretApi,
  AxiosGetSecretApi,
  AxiosPatchSecretApi,
} from "../../../utils/fetchApi";
import MainLayout from "../../../components/Layout/MainLayout";
import { Form, Input, Select, Button, Popconfirm, message } from "antd";
import { changeIdLogout } from "../../../redux/actions/socket.action";
import { connect } from "react-redux";
import Card from "../../../components/Card";

class EditUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listRole: [],
      listDepartment: [],

      isLoading: false,
      userID: undefined,
    };
    this.form = React.createRef();
  }

  componentDidMount() {
    this.getAllSelectData();
    this.getUserData();
  }

  componentDidUpdate(prevProps, prevState) {}

  async getAllSelectData() {
    let [listDepartment] = await Promise.all([
      AxiosGetSecretApi(`/api/user/phongban`),
    ]);

    listDepartment = listDepartment.map((e) => {
      return {
        name: e.MoTa,
        value: e.MaPhongBan,
      };
    });

    this.setState({
      listDepartment,
    });
  }

  async getUserData() {
    let id = this.props.match.params.id;
    let responseData = await AxiosGetSecretApi(`/api/user/${id}/info`);
    if (responseData) {
      let e = responseData;
      this.form.current.setFieldsValue({
        username: e.TenDangNhap,
        fullname: e.HoVaTen,
        role: e.Permistion,
        department: e.MaPhongBan,
      });
      this.setState({ userID: e.IDNguoiDung });
    }
  }

  handleSubmit() {
    this.setState({ isLoading: true });
    this.form.current
      .validateFields()
      .then((e) => {
        let data = {
          HoVaTen: e.fullname,
          Permistion: e.role,
          name: e.username ,
          password: e.password,
          valuePhongBan: e.department,
        };
        this.updateUser(data);
        this.setState({ isLoading: false });
      })
      .catch(this.setState({ isLoading: false }));
  }

  async updateUser(data) {
    let id = this.props.match.params.id;
    let response = await AxiosPatchSecretApi("/api/user/update/" + id, data);
    if (response.length > 0) {
      message.success("Cập nhật người dùng thành công");
      this.props.changeIdLogout(this.state.userID);
      setTimeout(()=>{this.props.history.push("/ql-nguoi-dung")}, 1000) 
    } else {
      message.error("Cập nhật người dùng không thành công");
    }
  }

  render() {
    return (
      <MainLayout {...this.props} title={"Quản lý người dùng"}>
        <div className="page-with-card">
          <Card title="Quản lý người dùng">
            <div className="create-user">
              <div className="content">
                <Form
                  onSubmit={this.handleSubmit}
                  style={{ width: "600px" }}
                  layout="vertical"
                  ref={this.form}
                >
                  <div className="sub-title">Chỉnh sửa người dùng</div>

                  <Form.Item
                    label="Tên đăng nhập"
                    style={{ marginBottom: "20px" }}
                    initialValue={this.state.username}
                    name="username"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập tên đăng nhập!",
                      },
                      {
                        message: "Vui lòng kiểm tra lại tên đăng nhập!",
                        pattern: new RegExp(
                          "^[a-zA-Z0-9]([._](?![._])|[a-zA-Z0-9]){0,50}[a-zA-Z0-9]$",
                          "g"
                        ),
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className="input" disabled/>
                  </Form.Item>

                  <Form.Item
                    label="Họ và tên"
                    style={{ marginBottom: "20px" }}
                    initialValue={this.state.fullname}
                    name="fullname"
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập họ và tên!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input className="input" />
                  </Form.Item>

                  <Form.Item
                    label="Quyền"
                    style={{ marginBottom: "20px" }}
                    initialValue={this.state.role}
                    name="role"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng chọn quyền!" },
                    ]}
                  >
                    <Select className="select" showSearch optionFilterProp = "name">
                      <Select.Option value="QuanTri" name = "Quản trị hệ thống">
                        Quản trị hệ thống
                      </Select.Option>
                      <Select.Option value="ChuyenVien" name = "Chuyên viên">
                        Chuyên viên
                      </Select.Option>
                      <Select.Option value="LanhDao" name = "Lãnh đạo">Lãnh đạo</Select.Option>
                      <Select.Option value="Khac" name = "Khác">Khác</Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Phòng ban"
                    style={{ marginBottom: "20px" }}
                    initialValue={this.state.department}
                    name="department"
                    hasFeedback
                    rules={[
                      { required: true, message: "Vui lòng phòng ban !" },
                    ]}
                  >
                    <Select className="select" showSearch optionFilterProp = "name">
                      {this.state.listDepartment.map((e, i) => (
                        <Select.Option value={e.value} key={i} name = {e.name}>
                          {e.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Popconfirm
                    title={"Bạn có chắc muốn cập nhật?"}
                    okText="Có"
                    cancelText="Không"
                    onConfirm={(e) => this.handleSubmit(e)}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Button
                        className="button-create-user"
                        type="primary"
                        htmlType="submit"
                        loading={this.state.isLoading}
                      >
                        Cập nhật
                      </Button>
                    </div>
                  </Popconfirm>
                </Form>
              </div>
            </div>
          </Card>
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    socket: state.socket.socket,
  };
};
const mapDispatchToProps = {
  changeIdLogout: changeIdLogout,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditUser);
